document.addEventListener('DOMContentLoaded', function () {
  const sliderSelector = '.benefits-swiper';
  if (!document.querySelector(sliderSelector)) return;

  let swiperInstance = null;

  function initSwiper() {
    const isMobile = window.innerWidth < 768;
    
    if (isMobile && swiperInstance === null) {
      swiperInstance = new Swiper(sliderSelector, {
        loop: true,
        speed: 600,
        centeredSlides: true,
        spaceBetween: 8,
        slidesPerView: 1.25,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
      });
    } 
    
    else if (!isMobile && swiperInstance !== null) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }
  
  initSwiper();
  
  window.addEventListener('resize', initSwiper);
});